// @refresh reset
import "@/constants/DateTimeLocale";
import { useWindowDetector } from '@/hooks/useWindowDetector';
import TapDetector from "@/utils/TapDetector";
import { PortalProvider } from '@gorhom/portal';
import { AnchorProvider } from '@nandorojo/anchor';
import { DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { Slot } from "expo-router";
import { lazy, Suspense } from 'react';
import { Platform } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { KeyboardProvider } from "react-native-keyboard-controller";
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { enableFreeze, enableScreens } from 'react-native-screens';
import "setimmediate";

const ToastyHost = lazy(() => import('@/components/Toast'));
const AlertHost = lazy(() => import('@/components/Alert'));

if (Platform.OS === 'web' && typeof window !== 'undefined') {
    require('smoothscroll-polyfill').polyfill();
}

enableFreeze(true);
enableScreens(true);

function RootLayout() {

    useWindowDetector();

    return (
        <KeyboardProvider>
            <ThemeProvider value={DefaultTheme}>
                <GestureHandlerRootView style={{ flex: 1 }}>
                    <TapDetector>
                        <SafeAreaProvider>

                            <PortalProvider>

                                <AnchorProvider>

                                    <Suspense fallback={null}>
                                        <Slot />
                                    </Suspense>

                                    <Suspense fallback={null}>
                                        <AlertHost />
                                    </Suspense>

                                    <Suspense fallback={null}>
                                        <ToastyHost />
                                    </Suspense>

                                </AnchorProvider>

                            </PortalProvider>
                        </SafeAreaProvider>
                    </TapDetector>
                </GestureHandlerRootView>
                
            </ThemeProvider>

        </KeyboardProvider>
    );
}

export default RootLayout;